import injectSheet from 'react-jss'
import CheckedIn from './CheckedIn'
import styles from './CheckedIn.styles'

export default injectSheet(styles)(CheckedIn)
